module.exports = __webpack_public_path__ + "static/assets/9cd025f61b3a916033bb131268b4760a.svg";